import { type FC } from "react";
import { Navigate } from "react-router";
import { useParams } from "react-router-dom";

export const SaleRedirect: FC = () => {
    const { id } = useParams();

    return (
        <Navigate to={`/history?uuid=${id}`} />
    );
};
